import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function nieuweSportclubModelsReducer(state = initialState.nieuweSportclubModels, action) {
    switch (action.type) {
        case types.UPDATE_NIEUWESPORTCLUB_MODEL: {
            let stateToUpdate = mergeDeep({}, state);
            stateToUpdate[action.body.tab] = action.body.model;
            return stateToUpdate;
        }

        default:
            return state;
    }
}